import "../styles/css/admin-style.css"
import React, {useContext, useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {AuthenticationHandler} from "../components/auth/AuthenticationHandler";
import {publicCustomerService} from "../services/publicCustomerService";
import {useForm} from "react-hook-form";
import notificationService from "../services/NotificationService";
import {getBusinessOrCustomerName} from "../shared/sharedFunctions";
import EnlargeMapModal from "../components/PublicJobSchedule/EnlargeMapModal";
import {AvailableDatePicker} from "../shared/components/AvailableDatePicker";


const EstimateSchedulingPage: React.FC = () => {
    const auth = useContext(AuthenticationHandler);
    const {state} = useLocation();
    const navigate = useNavigate()
    const { register, control, getValues, trigger, formState: {errors} } = useForm();
    const [map64, setMap64] = useState('')
    const [showMapModal, setShowMapModal] = useState(false)
    const [noDate, setNoDate] = useState(false)
    const [availableDates, setAvailableDates] = useState([])
    const [customerData, setCustomerData] = useState({
        firstName: '',
        lastName: '',
        standardizedAddress: '',
        homePhone: '',
        email: '',
        estimatedPriceLessPatchwork: 0,
        totalJobPrice: 0,
        priceAdjustments: [],
        webDiscountAmount: -0,
        patchworkPrice: 0,
        jobId: 0,
        streetNumber: '',
        streetPrefix: '',
        streetName: '',
        streetSuffix: '',
        streetPostDirection: '',
        city: '',
        state: '',
        postalCode: ''
    });
    function getMapBase64String() {
        if(map64 && map64 !== '')
            return `data:image/png;base64,${map64}`;
        return ''
    }
    useEffect(() => {
        document.body.classList.add('bg-white');
        if(state.requestData){
            const requestData = state.requestData;
            if(!requestData.homePhone){
                if(requestData.mobilePhone){
                    requestData.homePhone = requestData.mobilePhone
                } else if(requestData.workPhone){
                    requestData.homePhone = requestData.workPhone
                }
            }
            setMap64(requestData.imageDataBase64)
            setCustomerData(requestData)
            publicCustomerService.getAvailableDates(auth.webIdUniqueToken, requestData.jobId).then(r => {
                setAvailableDates(r.availableDates)
            })
        }
    },[])

    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async () => {
        const all = getValues()
        const validation = await trigger();
        if(!all.scheduleDate)
            setNoDate(true)
        if (!validation || !all.scheduleDate) {
            notificationService.warning("Missing Required Fields.");
            return;
        }

        setSubmitting(true);
        Promise.resolve(publicCustomerService.scheduleJob(auth.webIdUniqueToken, customerData.jobId, all.scheduleDate, all.webComments)).then(r => {
            setSubmitting(false);
            if(!r) return;
            navigate('thanks');
        })
    };
    return (
        <>
            <div className="view-estimate-container">
                <div className="estimate-form">
                    <div className="mb-4">
                        <img src="/logo/logoBigger.svg" alt="Barreca Blacktopping" className="logo"/>
                    </div>
                    <div className="card p-4 mb-3">
                        <h3 className="mb-4 fw-bold"><i className="far fa-map-location-dot text-icon me-1"></i> Property &
                            Area Information</h3>
                        <div className="row gx-5">
                            <div className="col-md-auto mb-3 mb-md-0 text-end">
                                <div className="map-thumbnail mb-2">
                                    <img alt='map' src={getMapBase64String()}/>
                                </div>
                                <a onClick={() => setShowMapModal(true)} role="button" data-bs-toggle="modal" data-bs-target="#map-modal">enlarge map <i
                                    className="far fa-external-link"></i></a>
                            </div>
                            <div className="col-md">
                                <div className="mb-2">
                                    <h3 className="mb-0">{getBusinessOrCustomerName(customerData)}</h3>
                                    <label className="light-label">contact name</label>
                                </div>
                                <div className="mb-2">
                                    <h3 className="mb-0">{customerData.standardizedAddress}</h3>
                                    <label className="light-label">property</label>
                                </div>
                                <div className="mb-2">
                                    <h3 className="mb-0">{customerData.homePhone}</h3>
                                    <label className="light-label">phone</label>
                                </div>
                                <div>
                                    <h3 className="mb-0">{customerData.email}</h3>
                                    <label className="light-label">email</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card p-4 mb-3">
                        <h3 className="mb-4 fw-bold"><i className="far fa-calendar text-icon me-1"></i> Schedule Start Date
                        </h3>
                        <div className="row">
                            <div className={'col-lg mb-3 mb-lg-0'}>
                                <AvailableDatePicker
                                    name="scheduleDate"
                                    label="Select Date"
                                    required
                                    control={control}
                                    errors={errors}
                                    availableDates={availableDates.map(dateStr => {
                                        const [year, month, day] = dateStr.split("-").map(Number);
                                        return new Date(year, month - 1, day); // Local midnight
                                    })}
                                    className={'form-control form-control-lg'}
                                />
                                {noDate && <div className="invalid-feedback">
                                    This field is required.
                                </div>}
                            </div>

                            <div className="col-lg">
                            <label>Optional Comments</label>
                                <textarea {...register('webComments')} className="form-control form-control-lg" rows={5}></textarea>
                            </div>
                        </div>
                    </div>
                    <div className="card p-4 mb-3">
                        <h3 className="mb-4 fw-bold"><i className="far fa-file-invoice text-icon me-1"></i> Payment
                            Information</h3>
                        <p className="mb-0">You will be sent an invoice for the job after it has been completed.</p>
                    </div>
                </div>
                <div className="estimate-sidebar">
                    <div className="esimate-cost p-3">
                        <label>Your estimate</label>
                        <h2>${customerData.totalJobPrice}</h2>
                    </div>
                    <hr/>
                    <div className="p-3">
                        <h3 className="mb-3">Summary</h3>
                        <div className="row mb-3 align-items-center justify-content-between">
                            <div className="col-auto">Sealcoating</div>
                            <div className="col-auto text-end">${customerData.estimatedPriceLessPatchwork}</div>
                        </div>
                        {customerData.patchworkPrice > 0 &&
                            <div className="row mb-3 align-items-center justify-content-between">
                                <div className="col-auto">Patchwork</div>
                                <div className="col-auto text-end">${customerData.patchworkPrice}</div>
                            </div>}
                        <div className="row align-items-center justify-content-between">
                            <div className="col-auto">Subtotal</div>
                            <div
                                className="col-auto text-end">${customerData.estimatedPriceLessPatchwork + customerData.patchworkPrice}</div>
                        </div>
                    </div>
                    <hr/>
                    {customerData.priceAdjustments.map(x => {
                        return (
                            <div className="row align-items-center justify-content-between">
                                <div className="col-auto">{x.adjustmentDescription}</div>
                                <div className="col-auto text-end text-success fw-bold">{x.adjustmentAmount}</div>
                            </div>
                        )
                    })}
                    <div className="row align-items-center justify-content-between">
                        <div className="col-auto">Web Discount</div>
                        <div className="col-auto text-end text-success fw-bold">{customerData.webDiscountAmount}</div>
                    </div>
                    <hr/>
                    <div className="row align-items-center justify-content-between mb-5">
                        <div className="col-auto">Total</div>
                        <div className="col-auto text-end text-primary fw-bold">${customerData.totalJobPrice}</div>
                    </div>
                    <button disabled={submitting} onClick={handleSubmit} type="button"
                            className="btn btn-primary btn-lg w-100 fw-bold py-4 mb-5"><i
                        className="far fa-check"></i> Schedule Work
                    </button>
                    <div className="row">
                        <div className="col-auto">
                            <i className="fas fa-question-circle fa-2x" style={{color: "#C1CBCF"}}></i>
                        </div>
                        <div className="col">
                            <p className="mb-0">Please contact Barreca with any questions or concerns.</p>
                        </div>
                    </div>
                </div>
            </div>
            <EnlargeMapModal base64String={map64} show={showMapModal} toggle={() => setShowMapModal(false)}/>
        </>
    )
}

export default EstimateSchedulingPage